import React from 'react';

import debounce from 'lodash/debounce';

import { Activity } from '../../../types/Activity';
import * as ActivitiesService from '../../../services/ActivitiesService';
import { ActivitiesSearchFilter } from '../../../services/ActivitiesService';

import AutoComplete, { AutoCompleteProps } from './AutoComplete';

export type ActivityItem = Pick<Activity, 'id' | 'title' | 'city'>;

type Props = AutoCompleteProps<ActivityItem> & {
  filterData?: Partial<ActivitiesSearchFilter>;
};

const getOptionLabel = (activity: ActivityItem | undefined): string => {
  if (!activity) return '';

  return `${activity.title}${activity.city ? ` [${activity.city}]` : ''}`;
};
const getOptionValue = (activity: ActivityItem): string => {
  return activity.id;
};

const loadActivitiesForAutoComplete = (
  filterData?: Partial<ActivitiesSearchFilter>
) =>
  debounce((query, callback) => {
    ActivitiesService.listActivitiesForAutoComplete({
      ...filterData,
      title: query,
    }).then(resp => callback(resp));
  }, 500);

const ActivitiesAutoComplete = (props: Props) => {
  return (
    <AutoComplete
      {...props}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      loadOptions={loadActivitiesForAutoComplete(props.filterData)}
    />
  );
};

export default ActivitiesAutoComplete;
